import React from 'react';
import {Route} from 'react-router-dom';
import AsyncPage from './async';

export default [
  <Route
    key="/business/services/wechat-mini-program"
    path="business/services/wechat-mini-program"
    element={<AsyncPage />}
  />,
];
